import React from "react";
import CardActivity from '../components/CardActivity'
import HeaderText from '../components/HeaderText'
import { Row, Col } from 'react-bootstrap'

class ActivityPage extends React.Component {

    render() {
        return (
            <div className="">
                <Row>
                    <Col className="header-text">
                        <HeaderText cardImage="http://placehold.jp/286x180.png" text1="ปรับใจ" cardTitle="" text2="ห้อง ม.2/1  คุณครูสมหมาย ชายล้วน" />
                    </Col>
                </Row>
                <Row>
                    <Col className="w-100 text-center bg-blue">
                        <CardActivity cardImage="http://placehold.jp/286x180.png" cardDescription="" cardTitle="" link="/homeroom" btnText="HOMEROOM" action="activity" />
                        <CardActivity cardImage="http://placehold.jp/286x180.png" cardDescription="" cardTitle="" btnText="FRIENDSHIP" action="activity" />
                    </Col>
                </Row>
            </div>
        );
    }
};

export default ActivityPage;